<template>
  <div id="game_04">
    <div class="wrapper">
      <div class="game" :style="{ backgroundImage: `url(${publicPath}img/game/04/bg.png)`}">
        <div class="chara" :style="{ backgroundImage: `url(${publicPath}img/game/04/icon_fujiwara.png)`}"></div>
        <div class="area">
          <div class="ball_wrapper">
            <div class="ball" :style="{ backgroundImage: `url(${publicPath}img/game/04/ball.png)`}"></div>
            <div class="failed" :style="{ backgroundImage: `url(${publicPath}img/game/04/ball_failed.png)`}"></div>
          </div>
        </div>
        <div class="counter">
          <div class="count c1" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c2" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c3" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c4" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c5" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c6" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c7" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c8" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c9" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
          <div class="count c10" :style="{ backgroundImage: `url(${publicPath}img/game/04/count.png)`}"></div>
        </div>
      </div>
    </div>
    <div class="btn"><a href="javascript:void(0)" :style="{ backgroundImage: `url(${publicPath}img/game/04/btn.png)`}"></a></div>

    <div class="frames">
      <div class="frame">
        <div class="img f1" :style="{ backgroundImage: `url(${publicPath}img/game/04/frame_01.png)`}"></div>
        <div class="img f2" :style="{ backgroundImage: `url(${publicPath}img/game/04/frame_02.png)`}"></div>
        <div class="img f3" :style="{ backgroundImage: `url(${publicPath}img/game/04/frame_03.png)`}"></div>
        <div class="img f4" :style="{ backgroundImage: `url(${publicPath}img/game/04/frame_04.png)`}"></div>
        <div class="img f5" :style="{ backgroundImage: `url(${publicPath}img/game/04/frame_05.png)`}"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    data() {
      return {
        // 変更不可 -------------------------
        publicPath: process.env.BASE_URL,
        // ---------------------------------
        state: {
          counter: 0,
          x: 0,
          y: 0,
          anim: false,
        },
        height: 468,
        width: 750,
        ballSize: 197,
        failedBallSize: 301,
        result: false
      }
    },
    mounted () {
      // let vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty('--vh', `${vh}px`)

      this.setPos()

      $('#game_04 .game .area .ball_wrapper').on('touchend', this.touchBall)
      $('#game_04 .btn a').on('touchend', this.end)
    },
    destroyed () {
      $('#game_04 .game .area .ball_wrapper').off('touchend', this.touchBall)
      $('#game_04 .btn a').off('touchend', this.end)
    },
    methods: {
      touchBall() {
        if(this.state.anim) return

        this.state.anim = !this.state.anim

        const xFlg = this.state.x > (this.width - this.ballSize) / 2
        const yFlg = this.state.y > (this.height - this.ballSize) / 2
        let moveX = 0
        let moveY = 0

        this.state.counter++;

        if(this.state.counter === 100) {
          this.result = !this.result
          this.setCounter()
          this.showFrame()

          setTimeout(this.sendResult, 3000)
          return
        }

        // ボールが逃げる移動量
        switch(true) {
          case xFlg && yFlg:
            // 左上
            moveX = this.state.x - 175
            moveY = this.state.y - 100
            break
          case xFlg && !yFlg:
            moveX = this.state.x - 175
            moveY = this.state.y + 100
            // 左下
            break
          case !xFlg && yFlg:
            moveX = this.state.x + 175
            moveY = this.state.y - 100
            // 右上
            break
          case !xFlg && !yFlg:
            moveX = this.state.x + 175
            moveY = this.state.y + 100
            // 右下
            break
        }

        $('#game_04 .game .area .ball_wrapper').animate({
          left: (moveX / 7.5) + 'vw',
          top: (moveY / 7.5) + 'vw'
        }, 300, 'swing', () => {
          $('#game_04 .game .area .ball_wrapper').addClass('miss')
          $('#game_04 .game .area .ball_wrapper').fadeOut(400, () => {
            switch(true){
              case this.state.counter % 20 === 0:
                // カウントアップ
                this.setCounter()
                this.showFrame()
                // コマ割り込み
                break
              case this.state.counter % 10 === 0:
                // カウントアップ
                this.setCounter()
                this.setPos()
                break
              default:
                this.setPos()
                break
            }

            this.state.anim = !this.state.anim
          })
        })
      },
      end() {
        this.sendResult()
      },
      /* ----- modules ----- */
      setPos() {
        this.state.x = this.rand(this.width - this.ballSize)
        this.state.y = this.rand(this.height - this.ballSize)

        $('#game_04 .game .area .ball_wrapper').css({
          left: this.state.x / 7.5 + 'vw',
          top: this.state.y / 7.5 + 'vw'
        })

        $('#game_04 .game .area .ball_wrapper').removeClass('miss')

        $('#game_04 .game .area .ball_wrapper').show()
        $('#game_04 .game .area .ball').show()
      },
      setCounter() {
        $(`#game_04 .game .counter .c${this.state.counter/10}`).show()
      },
      showFrame() {
        $(`#game_04 .frames .f${this.state.counter/20}`).show()
        $('#game_04 .frames').show()
        setTimeout(() => {
          $('#game_04 .frames .img').hide()
          $('#game_04 .frames').hide()
          this.setPos()
        }, 3000)
      },
      rand(size) {
        return Math.floor(Math.random() * size)
      },
      // ゲーム結果を送信 --- クリアの時は「true」、失敗の時は「false」-------------
      sendResult: function() {
        this.$emit('gameResult', this.result);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #game_04 {
    position: relative;
    // height: 100vh;
    // height: calc(var(--vh, 1vh) * 100);
    width: 100%;
    height: 100%;

    * {
      box-sizing: border-box;
    }

    .wrapper {
      // 100% - (.btnのheight + 上下margin)
      position: relative;
      height: calc(100% - 28.8vw);

      .game {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        width: 100%;
        height: 118.66vw;
        background: left bottom 10.93vw no-repeat;
        background-size: 100%;

        .chara {
          position: absolute;
          bottom: 32.26vw;
          left: 56.66VW;
          width: 16.66vw;
          height: 24vw;
          background: left top no-repeat;
          background-size: 100%;
          animation: 2s steps(2) 0s infinite none step;
        }

        .area {
          position: relative;
          width: 100%;
          height: 62.4vw;
          overflow: hidden;

          .ball_wrapper {
            position: absolute;
            width: 26.26vw;
            height: 26.26vw;

            &.miss {
              width: 40.13vw;

              .ball {
                display: none !important;
              }

              .failed {
                display: block;
              }
            }

            div {
              display: none;
              width: 100%;
              height: 100%;
              background: left top no-repeat;
              background-size: 100%;
            }
          }
        }

        .counter {
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          margin: 0 auto;
          width: 89.86vw;
          height: 7.73vw;

          .count {
            display: none;
            margin-right: 1.39vw;
            width: 7.73vw;
            height: 7.73vw;
            background: left top no-repeat;
            background-size: 7.73vw;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }

    .btn {
      margin: 6.4vw auto;
      height: 16vw;

      a {
        display: block;
        margin: 0 auto;
        width: 69.6vw;
        height: 16vw;
        background: left top no-repeat;
        background-size: 100%;
      }
    }

    .frames {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      width: 100%;
      height: 100%;

      .frame {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        width: 100%;
        height: 71.33vw;
      }

      .img {
        position: relative;
        width: 100%;
        height: 71.33vw;
        display: none;
        animation: .3s steps(2) 0s 2 none shake;
        background: left top no-repeat;
        background-size: 100%;
      }
    }
  }

  @keyframes shake {
    from {
      top: -25px;
    }
    to {
      top: 25px;
    }
  }
  @keyframes step {
    from {
      left: 56.66VW;
    }
    to {
      left: 59.33VW;
    }
  }
</style>
